import React from 'react';
import Card from './Card';
import { useTranslation } from 'react-i18next';
import BreadCrumbs from '../common/BreadCrumbs';
import Page from '../common/Page';
import { useLocation } from 'react-router-dom';

const CardPage = () => {

    const { t } = useTranslation();
    const location = useLocation();

    return (
        <Page>
            <BreadCrumbs stack={[
                {title: t("Domů"), path: "/"},
                {title: t("Historie karet"), path: ".."},
                {title: t("Detail"), path: location.pathname}
            ]} />
            <Card />
        </Page>
    );
};

export default CardPage;